import styled from 'styled-components';

export const TrackingSummaryContainer = styled.div(({ theme }) => ({
  borderTopLeftRadius: 3,
  borderTopRightRadius: 3,
  display: 'flex',
  padding: `${theme.spacing[8]} ${theme.spacing[16]}`,
  alignItems: 'flex-start',
  backgroundColor: theme.colors.indigoBlue,
}));
